"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function DryingCta() {
  const shouldReduceMotion = useReducedMotion();
  return <section id="dryingoperationscta" data-nav="dark" className="bg-sidebar text-sidebar-foreground py-16 md:py-24 relative overflow-hidden">
      {/* Subtle background decorative grid accents */}
      <div aria-hidden="true" className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-sidebar-accent/40 via-transparent to-transparent pointer-events-none" />

      <div className="page-container relative z-10">
        <motion.div initial={shouldReduceMotion ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        ease: "easeOut"
      }} className="max-w-3xl mx-auto text-center flex flex-col items-center justify-center space-y-6">
          <h2 className="font-default text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-sidebar-foreground text-balance">
            Ready to Eliminate Guesswork in Your Drying Operations?
          </h2>

          <p className="text-sidebar-foreground/80 text-base sm:text-lg max-w-2xl leading-relaxed">
            Partner with our process analytical technology specialists to optimize batch endpoints, ensure regulatory compliance, and improve yield.
          </p>

          <div className="pt-2">
            <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 font-semibold px-8 py-6 text-base rounded-md shadow-md transition-all group">
              <Link to="/ContactPage" className="inline-flex items-center gap-2">
                <span>Contact Our PAT Specialists</span>
                <ArrowRight className="size-5 transition-transform duration-200 group-hover:translate-x-1" />
              </Link>
            </Button>
          </div>
        </motion.div>
      </div>
    </section>;
}